import { render, staticRenderFns } from "./studentFormEntry.vue?vue&type=template&id=6f448990&"
import script from "./studentFormEntry.vue?vue&type=script&lang=js&"
export * from "./studentFormEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports